<template>
    <main class="main--gate">

        <div class="gate__inner text-center w-100 h-lg-100 py-60 py-md-80 py-lg-50 white--text">
            <v-container>
                <div class="mb-30 mb-lg-64">
                    <h2 class="tit--lg line-height-12 mb-16 mb-lg-28">
                        서울 용산시제품제작소
                    </h2>
                    <p class="tit-txt mb-lg-4">
                        서울형 기술제조 창업 플랫폼을 통해 <strong>제조기업</strong>을 지원합니다.
                    </p>
                    <p class="tit-txt">
                        <strong>시장판매 목적 제품</strong>의 공동개발, 제조, 교육을 지원합니다.
                    </p>
                </div>
                <v-row>
                    <v-col cols="6" md="3">
                        <gate-link href="/" target="_blank" tit="전자제조 지원센터" bgImage="/images/gate/gate-link1.jpg"></gate-link>
                    </v-col>
                    <v-col cols="6" md="3">
                        <gate-link noLink tit="모델링 지원센터" bgImage="/images/gate/gate-link2.jpg"></gate-link>
                    </v-col>
                    <v-col cols="6" md="3">
                        <gate-link href="https://digital-blacksmithshop.com/" target="_blank" tit="디지털 대장간" bgImage="/images/gate/gate-link3.jpg"></gate-link>
                    </v-col>
                    <v-col cols="6" md="3">
                        <gate-link href="http://y-valley.org/" target="_blank" tit="Y-valley 상상가" bgImage="/images/gate/gate-link4.jpg"></gate-link>
                    </v-col>
                </v-row>
            </v-container>
        </div>

        <footer class="footer w-100 py-30 py-lg-50">

            <v-container>

                <v-row class="flex-column-reverse flex-lg-row" align-lg="center">
                    <v-col cols="12" lg="7" xl="6">
                        <p class="footer__tit page-text font-weight-bold line-height-1 mb-8 mb-lg-14">
                            서울 용산 시제품제작소
                        </p>
                        <p class="footer__info">
                            서울특별시 용산구 청파로77 (원효전자상가6동) 2층, 3층 용산시제품제작소 (KEA) <br>
                            TEL : 02-6388-6192<span class="text-center d-none d-md-inline-block" style="width: 22px">|</span><br class="d-block d-md-none">
                            FAX : 070-7500-0095<span class="text-center d-none d-md-inline-block" style="width: 22px">|</span><br class="d-block d-md-none">
                            EMAIL : yes@gokea.org
                        </p>
                    </v-col>
                    <v-col cols="12" lg="5" xl="6" class="mb-20 mb-lg-0">
                        <v-row justify-lg="end" class="ma-n4 ma-xl-n20">
                            <v-col cols="4" xl="auto" class="pa-4 pa-xl-20">
                                <v-img src="/images/gate/partner-logo1.jpg" max-width="155" class="w-100"></v-img>
                            </v-col>
                            <v-col cols="4" xl="auto" class="pa-4 pa-xl-20">
                                <v-img src="/images/gate/partner-logo2.jpg" max-width="155" class="w-100"></v-img>
                            </v-col>
                            <v-col cols="4" xl="auto" class="pa-4 pa-xl-20">
                                <v-img src="/images/gate/partner-logo3.jpg" max-width="155" class="w-100"></v-img>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

            </v-container>

        </footer>
    </main>
</template>

<script>
import GateLink from "@/components/client/gate/gate-link.vue";

export default {
    components: {
        GateLink,
    },
    data: () => ({
    }),
    computed: {
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.gate__inner{
    background-position: center top;
    background-repeat: no-repeat;
    background-size: auto 70%;
    background-image: url(/images/gate/gate-bg.jpg);
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .main--gate{
        width: 100%;
        min-height: 100vh;
        padding-bottom: 181px;
    }
    .gate__inner{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .footer {
        position: absolute;
        bottom: 0;
        left: 0;
    }
}
@media (min-width:1200px){
    .gate__inner{
        background-size: 100% auto;
    }
}

</style>
